/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Cards_Printings_Copies_TitleInputs */



/**
* | output |
* | --- |
* | "Cards, Printings & Copies" |
*
* @param {Help_Article_Cards_Printings_Copies_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_cards_printings_copies_title = /** @type {((inputs?: Help_Article_Cards_Printings_Copies_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Cards_Printings_Copies_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Karten, Drucke & Exemplare")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cartes, éditions et exemplaires")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡牌、印刷版本与实体卡")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("卡牌、印刷版本與實體卡")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드, 인쇄판, 사본")
	return /** @type {LocalizedString} */ ("Cards, Printings & Copies")
});